module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/scroll-cbe1d6289ec7f4aef605db7f52839d2b.png";